/** The application logging boundary; callers never depend on console return values. */
export const logger = {
  error(...details: unknown[]): void {
    // eslint-disable-next-line no-console -- Logging is deliberately owned by this adapter.
    console.error(...details);
  },
  warn(...details: unknown[]): void {
    // eslint-disable-next-line no-console -- Logging is deliberately owned by this adapter.
    console.warn(...details);
  },
  info(...details: unknown[]): void {
    // eslint-disable-next-line no-console -- Logging is deliberately owned by this adapter.
    console.info(...details);
  },
};
